import React from 'react';

import styled from 'styled-components';

import StyleVariables from '@components/Gui/StyleVariables.js';

const StyledTag = styled.small`
    margin-right: 0.2em;
    margin-bottom: 0.2em;
    font-size: ${(props) => (props.$small ? '.6rem' : '.75rem')};
    line-height: 1.4em;
    font-weight: normal;
    background-color: ${(props) => props.$bgcolor};
    cursor: ${(props) => (props.$pointer ? 'pointer' : 'default')};
    color: ${(props) => (props.$blackfont ? '#000' : '#fff')};
    padding: ${(props) => (props.$small ? '.1em .3em' : '.25em .75em')};
    border-radius: 4px;
    white-space: nowrap;
    text-transform: ${(props) => (props.$uppercase ? 'uppercase' : 'inherit')};
`;

const nwTagColors = {
    danger: StyleVariables.DangerColor,
    dark: StyleVariables.PrimaryDark,
    warning: StyleVariables.WarningColor,
    primary: StyleVariables.PrimaryColor,
};

const NwTag = ({ type, children, pointer, uppercase, clickaction, style, small }) => {
    const blackfont = type && type === 'warning';

    return (
        <StyledTag
            onClick={clickaction}
            $blackfont={blackfont}
            $bgcolor={type ? nwTagColors[type] : StyleVariables.PrimaryDarkLight}
            $pointer={pointer}
            $uppercase={uppercase}
            style={style || {}}
            $small={small}
        >
            {children}
        </StyledTag>
    );
};

export { NwTag };
